import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';
import { ReferralInvitePage } from './referral-invite';

@NgModule({
    declarations: [ReferralInvitePage],
    imports: [PagesModule, ComponentsModule]
})
export class ReferralInvitePageModule {}
